module.exports = {
	"id": "MT",
	"name": "Malta",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.013682,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": 0.006841,
			"19": null,
			"20": null,
			"21": null,
			"22": 0.054728,
			"23": null,
			"24": null,
			"25": null,
			"26": 0.041046,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": 0.013682,
			"32": 0.027364,
			"33": 0.013682,
			"34": 0.013682,
			"35": 0.006841,
			"36": 0.041046,
			"37": 0.013682,
			"38": 0.027364,
			"39": 0.054728,
			"40": 0.054728,
			"41": 0.027364,
			"42": 0.027364,
			"43": 0.082092,
			"44": 0.061569,
			"45": 0.075251,
			"46": 0.047887,
			"47": 0.054728,
			"48": 0.793556,
			"49": 2.66799,
			"50": 0.225753,
			"51": 0.581485,
			"52": 0.533598,
			"53": 32.966779,
			"54": 8.729116,
			"55": 0.088933,
			"56": 0.027364,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": null,
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": null,
			"12": 0.006841,
			"13": null,
			"14": null,
			"15": null,
			"16": 0.013682,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": 0.013682,
			"30": null,
			"31": null,
			"32": null,
			"33": 0.006841,
			"34": null,
			"35": null,
			"36": 0.013682,
			"37": 0.006841,
			"38": 0.082092,
			"39": 0.013682,
			"40": null,
			"41": null,
			"42": 0.027364,
			"43": 0.088933,
			"44": 0.020523,
			"45": 0.082092,
			"46": 0.061569,
			"47": 0.314686,
			"48": 0.355732,
			"49": 4.672403,
			"50": 0.088933,
			"51": 0.013682,
			"52": null,
			"3.5": null,
			"3.6": 0.013682
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": 0.006841,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": null,
			"35": null,
			"36": 0.013682,
			"37": 0.020523,
			"38": 0.061569,
			"39": 0.020523,
			"40": 0.314686,
			"41": 0.061569,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": 0.061569
		},
		"safari": {
			"0": null,
			"4": 0,
			"5": 0.027364,
			"6": 0.013682,
			"7": 0.020523,
			"8": 0.171025,
			"9": 0.20523,
			"10": 2.428555,
			"3.1": null,
			"3.2": null,
			"5.1": 0.082092,
			"6.1": 0.027364,
			"7.1": null,
			"9.1": 1.149288
		},
		"ios_saf": {
			"8": 0,
			"10": 5.74422459617,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.154800206078,
			"8.1-8.4": 0.285986821399,
			"9.0-9.2": 0.136434079933,
			"9.3": 2.08149429642
		},
		"android": {
			"3": 0,
			"4": 0.0293125813953,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.00366407267442,
			"4.1": 0.105734668605,
			"4.2-4.3": 0.264336671512,
			"4.4": 0.60614230814,
			"4.4.3-4.4.4": 0.611376697674
		},
		"ie": {
			"6": null,
			"7": null,
			"8": 0.191548,
			"9": 0.246276,
			"10": 0.123138,
			"11": 4.617675,
			"5.5": null
		},
		"op_mob": {
			"0": 0.00784270786657,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.000217852996294
		},
		"edge": {
			"12": 0.082092,
			"13": 1.067196,
			"14": 2.086505
		},
		"ie_mob": {
			"10": 0.100287126761,
			"11": 0.408311873239
		},
		"bb": {
			"7": 0.0078975,
			"10": null
		},
		"samsung": {
			"0": 3.879252
		},
		"and_uc": {
			"0": 0.120042
		},
		"op_mini": {
			"0": 0.105663439137
		},
		"and_chr": {
			"0": 17.898285
		},
		"and_ff": {
			"0": 0.009477
		}
	},
	"total": 98.9321655
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/MT.json
 ** module id = 597
 ** module chunks = 0
 **/